<div class="notify-template" [class.empty]="isEmptyTemplate">
    <upsc-notify-template-thumbnail [template]="template"></upsc-notify-template-thumbnail>

    <div class="notify-template-footer">
        <h5 class="title">{{ removePlusSignFromTemplateName(template.TemplateName | decode | sanitize) }}</h5>
        <mat-radio-button value="{{ template.TemplateId }}" [disabled]="isEmptyTemplate">
            {{ 'notifyTemplates.makeDefaultTemplate'|translate }}
        </mat-radio-button>
        <div class="actions">
            <button mat-raised-button
                    color="primary"
                    type="button"
                    [disabled]="isEmptyTemplate"
                    (click)="showPreview($event)">{{ 'View'|translate }}
            </button>
            <button mat-raised-button
                    type="button"
                    [disabled]="isEmptyTemplate"
                    (click)="confirmTemplateRemoval($event)">{{ 'Remove'|translate }}
            </button>
        </div>
    </div>

    <upsc-element-blocker *ngIf="template.isInProgress"></upsc-element-blocker>
</div>
